export class BackgroundTaskFailureError extends Error {
  task: any

  constructor(msg: string, task: any) {
    super(msg)
    this.task = task
  }
}
